import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "14",
  "aria-hidden": "true",
  viewBox: "0 0 18 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M17.675.133c.203.14.325.372.325.619v10.5a.75.75 0 0 1-.484.7l-5.25 2a.73.73 0 0 1-.504.01l-5.746-1.913-5 1.906A.75.75 0 0 1 0 13.252v-10.5c0-.313.19-.59.484-.7l5.25-2a.73.73 0 0 1 .503-.01l5.747 1.913 5-1.906a.75.75 0 0 1 .694.084zM1.5 3.268v8.896l3.75-1.428V1.84zm9.75 8.943V3.293l-4.5-1.5v8.918zm1.5-.047 3.75-1.428V1.84l-3.75 1.429v8.896Z" }, null, -1)
  ])))
}
export default { render: render }